import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ChartWrapperComponent } from './chart-wrapper.component';
import { LineChartModule } from './line-chart/line-chart.module';

@NgModule({
   imports: [CommonModule, LineChartModule],
   declarations: [ChartWrapperComponent],
   exports: [ChartWrapperComponent],
})
export class ChartWrapperModule {}
